import classNames from 'classnames';
import React, { useEffect } from 'react';
import { Table } from 'react-bootstrap';
import { useFilters, usePagination, useTable } from 'react-table';
import styles from './style.module.scss';
import { useSelector } from 'react-redux';
import { NextIcon, PrevIcon } from 'assets';
// import NotRecord from '@/shared/components/not_record/NotRecord';
// import { statusColor } from 'shared/utils/Helper';

const RoleTable = ({
    data,
    TableWrapperStyle,
    TableContainerStyle,
    ColumnStyleIndex,
    TDStyle,
    TDTextStyle,
    FirstTableTD,
    ColumnStyle,
    CoumnHeadingStyle,
    columns,
    loading,
    showPagination = true,
    NotFoundIcon
}) => {
    const tableInstance = useTable({ columns, data, initialState: { pageIndex: 0, pageSize: 13 } }, useFilters, usePagination);
    const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page } = tableInstance;
    return (
        <div className={classNames(styles.TableWrapper, TableWrapperStyle && TableWrapperStyle)}>
            <div className={classNames(styles.TableContainer, TableContainerStyle && TableContainerStyle)}>
                <Table {...getTableProps()} className={classNames(styles.Table)}>
                    <thead className={classNames(styles.TableHead)}>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()} className={classNames('d-flex', styles.TableRow)}>
                                {headerGroup.headers.map((column, columnInx) => (
                                    <th
                                        {...column.getHeaderProps()}
                                        className={classNames(columnInx == ColumnStyleIndex - 1 ? CoumnHeadingStyle : styles.HeaderContainer, columnInx == 0 && FirstTableTD && FirstTableTD)}
                                    >
                                        {column.render('Header')}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    {loading ? (
                        <>Loading...</>
                    ) : data?.length > 0 ? (
                        <tbody {...getTableBodyProps()} className={classNames(styles.TableBody)}>
                            {page.map((row) => {
                                prepareRow(row);
                                return (
                                    <tr {...row.getRowProps()} className={classNames(styles.TableRow, 'mb-3')}>
                                        {row.cells.map((cell, inx) => (
                                            <td
                                                {...cell.getCellProps()}
                                                className={classNames(
                                                    inx == ColumnStyleIndex - 1 ? ColumnStyle : TDStyle ? TDStyle : styles.TableTD,
                                                    inx == 0 && FirstTableTD && FirstTableTD

                                                    // statusColor(cell?.row?.original?.status) ? styles[statusColor(cell?.row?.original?.status)?.tdStatus] : ''
                                                )}
                                            >
                                                <div className={classNames(TDTextStyle ? TDTextStyle : styles.Text)}>{cell.render('Cell')}</div>
                                            </td>
                                        ))}
                                    </tr>
                                );
                            })}
                        </tbody>
                    ) : NotFoundIcon ? (
                        ''
                    ) : (
                        // <NotRecord Icon={NotFoundIcon} />
                        ''
                        // <NotRecord />
                    )}
                </Table>
            </div>
        </div>
    );
};

export default RoleTable;
